module.exports = __webpack_public_path__ + "img/hidden.a57921dd.svg";